import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=50732d42&scoped=true"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=50732d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50732d42",
  null
  
)

export default component.exports